import React, { useEffect, useState } from 'react';
import Sidebar from './components/SideBar'
import Alert from './components/Alert'
import { HashRouter, Route, Routes } from 'react-router-dom';
import {
  Home,
  Admins,
  AdminLogin,
  Reports,
  Applications,
  Settings,
  Notifications,
  Groups,
  GroupDetail
} from './pages'
import UserState from './components/UserState';
import { useSelector } from 'react-redux';


function App() {
  const user = useSelector(state => state.userController.user)
  const [theme,setTheme] = useState('light')

  const toggleTheme = () => {
    setTheme(prev => {
      if(prev === 'light'){
        window.localStorage.setItem('theme','dark')
        return 'dark'
      }else {
        window.localStorage.setItem('theme','light')
        return 'light'
      }
    })
  }

  useEffect(()=>{
    const storageTheme = window.localStorage.getItem('theme')
    if(storageTheme){
      setTheme(storageTheme)
    }
  },[])
  return (
    <main className={`App ${theme}`}>
      <HashRouter >
        <Alert />
        {user && <Sidebar theme={theme} toggleTheme={toggleTheme} />}
        <UserState />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/groups/:id" element={<GroupDetail />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/login" element={<AdminLogin />}/>
        </Routes>
      </HashRouter>
    </main>
  );
}

export default App;
